import { Injectable } from '@angular/core';

export enum ResumeConsentStatus {
  Initial = 'initial_consent_given',
  Confirmed = 'resume_confirmed',
  Denied = 'resume_denied'
}

@Injectable({
  providedIn: 'root'
})
export class ResumeConsentService {

  private getKey(
    clientId: string | number,
    profileId: string | number
  ): string {
    return `resumeconsent_${clientId}_${profileId}`;
  }

  getStatus(
    clientId: string | number,
    profileId: string | number
  ): string | null {

    return sessionStorage.getItem(
      this.getKey(clientId, profileId)
    );
  }

  saveStatus(
    clientId: string | number,
    profileId: string | number,
    status: ResumeConsentStatus
  ): void {

    const key = this.getKey(
      clientId,
      profileId
    );

    if (status === ResumeConsentStatus.Confirmed) {

      const currentValue =
        sessionStorage.getItem(key);

      if (currentValue !== ResumeConsentStatus.Initial) {
        return;
      }
    }

    sessionStorage.setItem(
      key,
      status
    );
  }

  isConfirmed(
    clientId: string | number,
    profileId: string | number
  ): boolean {

    return this.getStatus(
      clientId,
      profileId
    ) === ResumeConsentStatus.Confirmed;
  }

  isInitialConsentGiven(
    clientId: string | number,
    profileId: string | number
  ): boolean {

    return this.getStatus(
      clientId,
      profileId
    ) === ResumeConsentStatus.Initial;
  }

  isDenied(
    clientId: string | number,
    profileId: string | number
  ): boolean {

    return this.getStatus(
      clientId,
      profileId
    ) === ResumeConsentStatus.Denied;
  }

  clear(
    clientId: string | number,
    profileId: string | number
  ): void {

    sessionStorage.removeItem(
      this.getKey(
        clientId,
        profileId
      )
    );
  }
}